import React from 'react';
import Flagship from '../../core/flagship';
import {Link} from 'react-router';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../../actions/appActions';
import { Header, Label, Divider, Dropdown, Input, Icon, Card } from 'semantic-ui-react';
import {throttle, empty, renderFieldValue} from '../../utils/helpers';
import '../../styles/search.scss';

class Search extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = this.getInitialState();
        this.search = this.search.bind(this);
        this.getSearch = this.getSearch.bind(this);
        this.searchInputChange = this.searchInputChange.bind(this);
        this.searchInputKeyUp = this.searchInputKeyUp.bind(this);
        this.dropdownChange = this.dropdownChange.bind(this);
        this.timer = null;
    }

    getInitialState() {

        return {
            currentSearch: empty(this.props.location.query.search) ? '' : this.props.location.query.search,
            currentType: "any",
            currentPage: 1,
            records: {},
            totalPages: 1,
            loading: true
        }
    }

    componentDidMount() {
        document.title = 'Flagship / Search';
    }

    componentWillMount() {
        // Call API
        if (!empty( this.props.location.query.search ) ) {
            this.getSearch();
        }
        setTimeout(Flagship.closeSidebarNav,500);
    }

    componentWillReceiveProps(nextProps) {

        if ( nextProps.route.type !== this.props.route.type ) {
            this.setState(this.getInitialState(), this.getSearch);
        }
    }

    getSearch() {

        if (!empty(this.state.currentSearch)) {

            let type = ( !empty(this.props.route.type) ? this.props.route.type : 'any' );

            let self = this;

            Flagship.get(
                'search/' + type + '/' + this.state.currentPage,
                {
                    search: this.state.currentSearch
                },
                function (response) {
                    if (response.data.success === true) {

                        self.setState({
                            records: response.data.results,
                            loading: false
                        });

                    } else {
                        Flagship.error("Error getting records from Flagship API server.");
                    }
                }
                , function (err) {
                    Flagship.error("Error getting records from Flagship API server: " + err);
                    Flagship.redirect('/login');
                }
            );
        } else {
            this.setState({
                records: {},
                loading: false
            })
        }
    }


    search(e) {
        e.persist();
        let filterSearch = this.filterSearch;
        this.timer = throttle( function() {
            filterSearch(e.target.value);
        }, 500, this.timer);
    }

    searchInputKeyUp(e) {

        if (e.which === 13) {
            this.setState({
                loading:true
            }, this.getSearch());
        }
    }

    searchInputChange(e) {
        this.setState({
           currentSearch: e.target.value
        });
    }

    dropdownChange(e,data) {

        if (data.value === "favorites") {
            Flagship.redirect("/user/favorites?search=" + this.state.currentSearch);
        } else {
            this.setState({
                currentType: data.value
            });
        }
    }

    render() {

        const getCardHeading = (name, key, type, market) => {
            let icon = 'exclamation';
            switch (type) {
                case 'client':
                    icon = 'briefcase';
                    break;
                case 'rfp':
                    icon = 'dollar';
                    break;
                case 'io':
                    icon = 'rocket';
                    break;
            }

            return (
                <div>
                    <h3 className="blue-text">
                        <Icon className="feed-icon" disabled size="large" color="grey" name={icon} />
                        {type === "rfp" || type ==="io" ? "#" + key : name }
                    </h3>
                    <h4 style={{marginTop:"0px"}}>{type === "rfp" || type ==="io" ? name : market }</h4>
                </div>

            );
        };

        let options = [
            {text: "All Records", value: "any"},
            {text: "Clients", value: "client"},
            {text: "RFPs", value: "rfp"},
            {text: "IOs", value: "io"},
            {text: "My Favorites", value: "favorites"}
        ];

        return (
            <div className="fade-in">
                <div id="view-header-section">
                    <h1 className="view-title">Search {!empty(this.state.records) ? "Results" : null}</h1>
                    <div style={{marginTop:"1em"}}>
                        <Dropdown
                            className="search-record-type"
                            selection
                            placeholder="Select..."
                            options={options}
                            value={this.state.currentType}
                            onChange={this.dropdownChange}
                        />
                        <Input
                            type="search"
                            size="large"
                            autoFocus={true}
                            value={this.state.currentSearch}
                            className="search-input"
                            placeholder="Enter Search Here..."
                            onChange={this.searchInputChange}
                            onKeyUp={this.searchInputKeyUp}
                        />
                    </div>
                </div>
                <Divider />

                {!empty(this.state.records) ?

                    <div>

                        {!empty(this.state.records.client) && (this.state.currentType === "any" || this.state.currentType === "client" ) ?
                            <div>
                                <Header as="h2" className="white-text cf">Clients</Header>
                                <Card.Group className="search-results cf">

                                    {this.state.records.client.map(function(item, i) {
                                        return (
                                            <Card className="single-search-result" key={"client-result-" + i}>
                                                <Link className="content" to={'/' + item.record_type + '/view/' + item.record_key}>
                                                    <Card.Content>
                                                        <Card.Header>
                                                            {getCardHeading(item.record_name, item.record_key, item.record_type, item.market)}
                                                        </Card.Header>
                                                        <Card.Description>
                                                            {!empty(item.extra1) ?
                                                                <div className="search-details">
                                                                    <Label>{Flagship.config.records[item.record_type].extra1.label}</Label><br/>
                                                                    <div className="field-value">{renderFieldValue(item.extra1, Flagship.config.records[item.record_type].extra1.validation)}</div>
                                                                </div> : null
                                                            }
                                                            {!empty(item.extra2) ?
                                                                <div className="search-details">
                                                                    <Label>{Flagship.config.records[item.record_type].extra2.label}</Label><br/>
                                                                    <div className="field-value">{renderFieldValue(item.extra2, Flagship.config.records[item.record_type].extra2.validation)}</div>
                                                                </div> : null
                                                            }
                                                            {!empty(item.extra3) ?
                                                                <div className="search-details">
                                                                    <Label>{Flagship.config.records[item.record_type].extra3.label}</Label><br/>
                                                                    <div className="field-value">{renderFieldValue(item.extra3, Flagship.config.records[item.record_type].extra3.validation)}</div>
                                                                </div> : null
                                                            }
                                                        </Card.Description>
                                                    </Card.Content>
                                                </Link>
                                            </Card>
                                        );
                                    })}
                                </Card.Group>
                                <Divider />
                            </div>: null }

                        {!empty(this.state.records.rfp) && (this.state.currentType === "any" || this.state.currentType === "rfp") ?
                            <div>
                                <Header as="h2" className="white-text">RFPs</Header>
                                <Card.Group className="search-results">
                                    {this.state.records.rfp.map(function(item, i) {
                                        return (
                                            <Card className="single-search-result" key={"rfp-result-" + i} href={'/' + item.record_type + '/view/' + item.record_key}>
                                                <Link className="content" to={'/' + item.record_type + '/view/' + item.record_key}>
                                                    <Card.Content>
                                                        <Card.Header>
                                                            {getCardHeading(item.record_name, item.record_key, item.record_type, item.market)}
                                                        </Card.Header>
                                                        <Card.Description>
                                                            {!empty(item.extra1) ?
                                                                <div className="search-details">
                                                                    <Label>{Flagship.config.records[item.record_type].extra1.label}</Label><br/>
                                                                    <div className="field-value">{renderFieldValue(item.extra1, Flagship.config.records[item.record_type].extra1.validation)}</div>
                                                                </div> : null
                                                            }
                                                            {!empty(item.extra2) ?
                                                                <div className="search-details">
                                                                    <Label>{Flagship.config.records[item.record_type].extra2.label}</Label><br/>
                                                                    <div className="field-value">{renderFieldValue(item.extra2, Flagship.config.records[item.record_type].extra2.validation)}</div>
                                                                </div> : null
                                                            }
                                                            {!empty(item.extra3) ?
                                                                <div className="search-details">
                                                                    <Label>{Flagship.config.records[item.record_type].extra3.label}</Label><br/>
                                                                    <div className="field-value">{renderFieldValue(item.extra3, Flagship.config.records[item.record_type].extra3.validation)}</div>
                                                                </div> : null
                                                            }
                                                        </Card.Description>
                                                    </Card.Content>
                                                </Link>
                                            </Card>
                                        );
                                    })}
                                </Card.Group>
                                <Divider />
                            </div>: null }

                        {!empty(this.state.records.io) && (this.state.currentType === "any" || this.state.currentType === "io") ?
                            <div>
                                <Header as="h2" className="white-text">IOs</Header>
                                <Card.Group className="search-results">
                                    {this.state.records.io.map(function(item, i) {
                                        return (
                                            <Card className="single-search-result" key={"io-result-" + i} href={'/' + item.record_type + '/view/' + item.record_key}>
                                                <Link className="content" to={'/' + item.record_type + '/view/' + item.record_key}>
                                                    <Card.Content>
                                                        <Card.Header>
                                                            {getCardHeading(item.record_name, item.record_key, item.record_type, item.market)}
                                                        </Card.Header>
                                                        <Card.Description>
                                                            {!empty(item.extra1) ?
                                                                <div className="search-details">
                                                                    <Label>{Flagship.config.records[item.record_type].extra1.label}</Label><br/>
                                                                    <div className="field-value">{renderFieldValue(item.extra1, Flagship.config.records[item.record_type].extra1.validation)}</div>
                                                                </div> : null
                                                            }
                                                            {!empty(item.extra2) ?
                                                                <div className="search-details">
                                                                    <Label>{Flagship.config.records[item.record_type].extra2.label}</Label><br/>
                                                                    <div className="field-value">{renderFieldValue(item.extra2, Flagship.config.records[item.record_type].extra2.validation)}</div>
                                                                </div> : null
                                                            }
                                                            {!empty(item.extra3) ?
                                                                <div className="search-details">
                                                                    <Label>{Flagship.config.records[item.record_type].extra3.label}</Label><br/>
                                                                    <div className="field-value">{renderFieldValue(item.extra3, Flagship.config.records[item.record_type].extra3.validation)}</div>
                                                                </div> : null
                                                            }
                                                        </Card.Description>
                                                    </Card.Content>
                                                </Link>
                                            </Card>
                                        );
                                    })}
                                </Card.Group>
                                <Divider />
                            </div>: null }


                    </div>

                    :
                    <div className="white-text">
                        {empty(this.currentSearch) ? "Enter search terms above and press ENTER to search." : "No results found."}
                    </div>
                }

            </div>
        );
    }
}

Search.propTypes = {
    actions: PropTypes.object,
    token: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    token: state.main.token,
  };
}

function mapDispatchToProps(dispatch) {

  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Search);





// WEBPACK FOOTER //
// ./src/components/views/Search.js